// Lib
import DefaultCodeMark from '@tiptap/extension-code';

/**
 * Supports formatting within inline code blocks
 */
export const CodeMark = DefaultCodeMark.extend({
    // The default code mark excludes every other mark. Only itself here, so formatting, links
    // and inline comments can sit on code text. `marks:` is a node setting and did nothing on a mark.
    excludes: 'code',

    // Needs to be more than text style (101) and link (1000) so that the <code> tag wraps the <a> or <span> tag
    priority: 1001,
});
